import settings from 'Cloud/settings';
import { IS_BIZ_USER } from 'reactApp/appHelpers/configHelpers';
import { getFeatureAlbumFavorites } from 'reactApp/modules/features/features.selectors';
import { EStorageType, IEnabledActions } from 'reactApp/modules/storage/storage.types';
import { store } from 'reactApp/store';

const disabledAll: IEnabledActions = {
    copy: false,
    move: false,
    remove: false,
    rename: false,
    history: false,
    favorites: false,
    publish: false,
    share: false,
    openParentFolder: false,
    download: false,
    add: false,
    view: false,
    sort: false,
    facesFilter: false,
    selectAll: false,
    mount: false,
    sendViaMail: false,
    publishAlbum: false,
    addToAlbum: false,
};

export const STORAGE_CONFIG = {
    [EStorageType.home]: {
        ...disabledAll,
        publish: true,
        copy: true,
        favorites: true,
        move: true,
        rename: true,
        share: true,
        remove: true,
        history: true,
        download: true,
        add: true,
        sort: true,
        view: true,
        selectAll: true,
        createFolder: true,
    },
    [EStorageType.search]: {
        ...disabledAll,
        openParentFolder: true,
        publish: true,
        copy: true,
        favorites: true,
        move: true,
        rename: true,
        share: true,
        remove: true,
        history: true,
        download: true,
        view: true,
        selectAll: true,
        add: true,
    },
    [EStorageType.sharedIncoming]: {
        ...disabledAll,
        share: true,
        remove: true,
        download: true,
        selectAll: true,
        mount: true,
        add: true,
        sort: IS_BIZ_USER,
    },
    [EStorageType.sharedLinks]: {
        ...disabledAll,
        publish: true,
        share: true,
        download: true,
        sort: true,
        view: true,
        selectAll: true,
        add: true,
    },
    [EStorageType.sharedAutodelete]: {
        ...disabledAll,
        publish: true,
        share: true,
        view: true,
        favorites: false, // не приходит флаг из апи v2
        openParentFolder: false, // путь до папки не приходит в нужном регистре
        remove: true,
        rename: true,
        move: true,
        selectAll: true,
        add: true,
    },
    [EStorageType.public]: {
        ...disabledAll,
        remove: true,
        view: true,
        sort: true,
        download: true,
        clone: true,
        add: true,
        shareLink: true,
        selectAll: true,
        facesFilter: true,
    },
    [EStorageType.favorites]: {
        ...disabledAll,
        openParentFolder: true,
        publish: true,
        copy: true,
        favorites: true,
        move: true,
        share: true,
        remove: true,
        view: true,
        selectAll: true,
        add: true,
        sort: IS_BIZ_USER,
        download: true,
    },
    [EStorageType.feed]: {
        ...disabledAll,
        openParentFolder: true,
        publish: true,
        copy: true,
        move: true,
        share: true,
        remove: true,
        view: true,
        download: true,
        selectAll: true,
        add: true,
    },
    [EStorageType.gallery]: {
        ...disabledAll,
        openParentFolder: true,
        publish: true,
        copy: true,
        favorites: true,
        move: true,
        rename: true,
        share: true,
        remove: true,
        history: true,
        download: true,
        view: true,
        selectAll: true,
        add: true,
        sort: IS_BIZ_USER,
    },
    [EStorageType.documents]: {
        ...disabledAll,
        openParentFolder: true,
        publish: true,
        copy: true,
        favorites: true,
        move: true,
        rename: true,
        share: true,
        remove: true,
        history: true,
        download: true,
        add: true,
    },
    [EStorageType.start]: {
        ...disabledAll,
        publish: true,
        copy: true,
        favorites: true,
        move: true,
        rename: false,
        share: true,
        remove: true,
        history: true,
        add: true,
        sort: IS_BIZ_USER,
    },
    [EStorageType.trashbin]: {
        ...disabledAll,
        restore: true,
        restoreAll: true,
        clear: true,
        selectAll: true,
        add: true,
        sort: IS_BIZ_USER,
    },
    [EStorageType.attaches]: {
        ...disabledAll,
        download: true,
        view: true,
        sendViaMail: true,
        clone: true,
        publish: true,
        add: true,
        sort: IS_BIZ_USER,
    },
    [EStorageType.viewerAttaches]: {
        ...disabledAll,
        download: true,
        view: true,
        sendViaMail: true,
        clone: true,
        publish: true,
    },
    [EStorageType.stock]: {
        ...disabledAll,
        view: true,
        sort: true,
        download: true,
        clone: true,
        selectAll: true,
    },
    [EStorageType.documents]: {
        ...disabledAll,
        openParentFolder: true,
        remove: true,
        move: true,
        copy: true,
        publish: true,
        favorites: true,
        selectAll: true,
        download: true,
        add: true,
    },
    [EStorageType.quotaCleaner]: {
        ...disabledAll,
        selectAll: true,
        back: true,
        view: true,
        download: true,
    },
    [EStorageType.albums]: {
        ...disabledAll,
        selectAll: true,
        remove: true,
        favorites: getFeatureAlbumFavorites(store.getState()),
        publish: true,
        view: true,
        download: true,
        rename: true,
        add: true,
    },
    [EStorageType.recommend]: {
        ...disabledAll,
        add: true,
    },
    [EStorageType.alldocuments]: {
        ...disabledAll,
        openParentFolder: true,
        publish: true,
        copy: true,
        move: true,
        share: true,
        remove: true,
        view: true,
        download: true,
        selectAll: true,
        createFolder: false,
        add: true,
    },
    [EStorageType.pdfEdit]: {
        ...disabledAll,
        publish: true,
        favorites: true,
        download: true,
    },
    [EStorageType.integration]: {
        ...disabledAll,
        publish: true,
    },
};

export const getStorageConfig = (storage: EStorageType): IEnabledActions => {
    const config = STORAGE_CONFIG[storage] || {};

    const oldSettings = settings?.storages?.[storage]?.settings ?? {};

    return { ...oldSettings, ...config };
};
